import DesignTokens from '@tableau/design-tokens';
import { ButtonType, ButtonWidget, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { ScreenReaderService } from '~src/commonInfra/services/ScreenReaderService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../../../style';

export interface ExplorerEmptyStateProps {
  readonly iconUrl?: string;
  readonly iconStyleOverrides?: React.CSSProperties;
  readonly primaryMessage: string;
  readonly secondaryMessage?: string;
  readonly actionButtonMessage?: string;
  readonly onActionButton?: () => void;
  readonly dataTestId?: string;
  readonly icon?: (props: any) => React.ReactSVGElement | null;
  readonly learnMorehref?: string;
  readonly learnMoreMessage?: string;
  readonly useContentTypeEmptyStateMessage?: boolean;
}

export const ExplorerEmptyState = (props: ExplorerEmptyStateProps): JSX.Element => {
  const screenReaderMessage = props.secondaryMessage ? (props.primaryMessage + props.secondaryMessage) : props.primaryMessage;
  ScreenReaderService.instance.setScreenReaderMessage(screenReaderMessage);
  return (
    <div style={CommonStyles.Layout.FlexVerticalAndHorizontalCenter}>
      <div data-tb-test-id={props.dataTestId} className={NoContentContainer}>
        {props.iconUrl &&
          <img alt="" style={{...NoContentImg, ...props.iconStyleOverrides}} src={props.iconUrl} />
        }
        {props.icon && props.icon({size: ExplorerStyles.EMPTY_STATE_ICON_SIZE })}
        <div className={Primary}>
          {props.primaryMessage}
        </div>
        {props.secondaryMessage &&
          <div className={Secondary}>
            {props.secondaryMessage}
          </div>
        }
        {props.actionButtonMessage && props.onActionButton &&
          <ButtonWidget buttonType={ButtonType.Outline}
            children={props.actionButtonMessage}
            handleClick={props.onActionButton}
            testId={'empty-state-action'}
            style={{marginTop: 24}}
          />
        }
        {
          props.learnMorehref && props.learnMoreMessage &&
          <TextLinkWidget target={'_blank'}
                          href={props.learnMorehref}
                          className={learnMoreStyle}
                          testId={props.dataTestId}
          >
            {props.learnMoreMessage}
          </TextLinkWidget>
        }
      </div>
    </div>
  );
};

const cssPrefix = 'no-content';
const NoContentContainer = cssClass(cssPrefix, 'container', {
  height: '100%',
  maxWidth: '650px',
  display: 'flex',
  flexDirection:'column',
  justifyContent: 'center',
  alignItems: 'center',
  left: 0,
  top: 0
});

const NoContentImg = {
  height: 80,
  width: 80,
  display: 'block',
  margin: '0 auto'
};

const Primary = cssClass(cssPrefix, 'primary', {
  marginTop: 32,
  fontSize: '18px',
  color: applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.Grey51),
  textAlign: 'center'
});

const Secondary = cssClass(cssPrefix, 'secondary', {
  marginTop: 16,
  fontSize: '14px',
  color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey77),
  textAlign: 'center'
});
